
/**
 * 浏览器类型判断
 * 
 * brower.versions.ios
 * 
 */
module.exports = {
	versions:function(){
		var u = navigator.userAgent;
		return {
			mobile: !!u.match(/AppleWebKit.*Mobile.*/)||!!u.match(/AppleWebKit/), //是否为移动终端
			ios: !!u.match(/(i[^;]+\;(U;)? CPU.+Mac OS X)/), //ios终端
			android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
       };
	}(),
	language:(navigator.browserLanguage || navigator.language).toLowerCase()
		
}


//////////////////
// WEBPACK FOOTER
// ./src/main/javascript/func/browser.js
// module id = 4
// module chunks = 0